/**
 * Wraps the markup from the Infinite Options app. Hides the infinite option
 * fields and creates proxy fields styled to match the product's native fields.
 */
if (!customElements.get("infinite-options")) {
  customElements.define(
    "infinite-options",
    class InfiniteOptions extends HTMLElement {
      constructor() {
        super();

        this.inputs = null;
        this.options = [];

        const baseFields = document.querySelectorAll(
          "variant-selects .product__accordion--variant",
        );
        this.baseField = Array.from(baseFields).pop();
        this.baseOptionCount = baseFields.length;

        if (!this.baseField) return;

        this.figureData = JSON.parse(this.querySelector('[type="application/json"]').textContent);

        // App scripts are deferred so we need to wait for the fields to be ready
        const observer = new MutationObserver(() => {
          if (!this.querySelector("[role='group']")) {
            return;
          }

          this.fields = this.querySelectorAll("[role='group']");
          this.onFieldsReady();
          observer.disconnect();
        });

        observer.observe(this, { childList: true, subtree: true });
      }

      onFieldsReady() {
        // Support setting options from URL query params
        const optionQueryParams = new URLSearchParams(window.location.search).get('io')?.split(',');

        this.options = Array.from(this.fields).map((field, index) => {
          const label = field.querySelector("label");
          const inputs = Array.from(field.querySelectorAll("input"));
          const values = inputs.map((input) => input.value);
          let selectedValue = values[0];
          inputs.find((input) => {
            if (input.checked) {
              selectedValue = input.value;
            }
            if (optionQueryParams?.includes(input.value)) {
              selectedValue = input.value;
              return;
            }
          });

          return {
            index,
            label: label.innerText,
            name: inputs[0].name,
            inputs,
            values,
            selectedValue,
          };
        });

        this.options.map((option) => {
          this.createOptionField(option);  
        });
        this.classList.add('visually-hidden');

        const variantSelects = document.querySelector(`[id^="variant-selects-${this.dataset.section}"]`);
        if (variantSelects) {
          variantSelects.onFieldsUpdated();
        }
      }

      createOptionField(option) {
        const newOptionField = this.baseField.cloneNode(true);

        newOptionField.querySelector("details[open]")?.removeAttribute("open");
        newOptionField.querySelector(".accordion__title").textContent =
          option.label;
          const translatedValue = option.selectedValue.toLowerCase() === "left"
          ? "Lewa"
          : option.selectedValue.toLowerCase() === "right"
          ? "Prawy"
          : option.selectedValue;
          newOptionField.querySelector(".summary__text").textContent = translatedValue;
          // newOptionField.querySelector(".summary__text").textContent =
          //   option.selectedValue;
        newOptionField.querySelector(".summary__text").setAttribute('data-selected-swatch-value', option.name)
        newOptionField.querySelector(".accordion__chip").textContent = String(
          this.baseOptionCount + 1 + option.index,
        ).padStart(2, "0");

        let figure = ''
        const inputs = option.inputs
          .map((input, index) => {
            const id = `${input.name}-${input.value}-${index}`;
            figure = this.figureData[input.value]
            const label = figure ? `
              <img src="${figure}" alt="${input.value}" loading="lazy" />
            ` : input.value
            const inputValue = input.value; // Retrieve the input value
            const translatedValue = inputValue === "Left"
              ? "Lewa"
              : inputValue === "Right"
              ? "Prawy"
              : inputValue; // Translate Left/Right
            return `
              <input type="radio" id="${id}" name="${input.name}" value="${input.value}" ${input.value === option.selectedValue ? 'checked' : ''}>
              <label for="${id}" title="${translatedValue}">${label}</label>
            `;
          })
          .join("");

        newOptionField.querySelector(".accordion__content").innerHTML = `
          <fieldset class="infinite-options js product-form__input product-form__input--pill${figure ? ' product-form__input--figure' : ''}">
            <legend class="form__label visually-hidden">
              ${option.label}:
              <span data-selected-swatch-value="${option.name}">${option.selectedValue}</span>
            </legend>
            ${inputs}
          </fieldset>     
        `;

        newOptionField.querySelectorAll("input").forEach((input, index) => {
          input.addEventListener("change", (event) => {
            this.options.find((option) => option.name === input.name).inputs[index].click();
          });
        })

        document.querySelector("variant-selects").appendChild(newOptionField);
      }
    },
  );
}
